import { Link } from 'react-router-dom';

import urlEncode from '../urlEncode';

const formatForFeed = function formatDataForSemanticUiCardFeed(
  data,
  languageId,
  match
) {
  return data
    .filter(card => card.snippet.title !== 'Private video')
    .map(card => {
      let cardData = {};
      // Check for English and Spanish localizations from YouTube Data
      if (languageId === 1 && card.localizations) {
        cardData = card.localizations.en || card.snippet;
      } else if (card.localizations) {
        cardData = card.localizations.es || card.snippet;
      } else {
        cardData = card.snippet;
      }
      return {
        header: cardData.title,
        image: card.snippet.thumbnails.medium.url,
        description: cardData.description,
        id: card.id,
        meta: card.releaseDate,
        as: Link,
        to: `${match.url}/${urlEncode(card.snippet.title)}/${card.id}`,
        languageId,
      };
    });
};

export default formatForFeed;



// WEBPACK FOOTER //
// ./src/components/getEpisodes/formatForFeed.js